export * from "modules/HoldingAppointmentDetails/components/CarDetails/components/CustomerInfo";
